import React from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import RelatorioCursos from "../components/RelatorioCursos";

const RelatorioCursosPage = () => {
    return (
        <>
            <div className="main-content">
                <Navbar/>
            </div>
            <div className="content">
                <Sidebar/>
            </div>
            <div className='table-rel-cursos'>
                <RelatorioCursos/>
            </div>
        </>
    );
};

export default RelatorioCursosPage;